import React, { Component } from 'react';

import Theme from 'Theme';

import DropZone from './components/DropZone';
import Button from 'components/Button';
import { MarginTop } from './components/Styled';
import PendingFile from './components/PendingFile';
import { MessagePopIn } from 'components/ToolTip';
import DocumentDescription from './components/DocumentDescription';

const INITIAL_STATE = {
  file: null,
  description: ''
};

export class FileUploader extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onFileDrop = this.onFileDrop.bind(this);
    this.onFileDelete = this.onFileDelete.bind(this);
    this.onFileSelected = this.onFileSelected.bind(this);

    this.state = INITIAL_STATE;
  }

  onFileDelete() {
    this.setState({ file: null });
  }

  onChange(name, value) {
    this.setState(() => ({ [name]: value }));
  }

  onSubmit() {
    let { file, description } = this.state;
    let { handleUpload } = this.props;

    handleUpload(file, description);
  }

  onFileSelected({ target: { files = [] } }) {
    const file = files[0];

    // TODO handle error
    if (!file) return;

    this.setState(() => ({
      file: file
    }));
  }

  onFileDrop(files) {
    const file = files[0];

    if (!file) return;

    this.setState(() => ({
      file: file
    }));
  }

  hasFile() {
    return !!this.state.file;
  }

  render() {
    let { file, description } = this.state;
    let { loading } = this.props;

    const FileButton = (
      <Button.Upload
        pendingFile={!!file}
        onChange={this.onFileSelected}
        loading={loading}
      />
    );

    const UploadButton = (
      <Button.Primary
        icon={'cloud_upload'}
        color={Theme.successColor}
        disabled={!file || !description}
        label={'Upload File'}
        onClick={this.onSubmit}
      />
    );

    return (
      <div>
        <PendingFile
          file={file}
          description={description || 'New File'}
          onFileDelete={this.onFileDelete}
        />

        {file && (
          <DocumentDescription onChange={this.onChange} value={description} />
        )}

        <MarginTop margin={'8px'} />

        <DropZone file={file} onChange={this.onFileDrop} />

        {!file ? (
          FileButton
        ) : (
          <MessagePopIn
            inline
            hide={!file || !description}
            message="Your document is ready to be uploaded. Click here to upload."
          >
            {UploadButton}
          </MessagePopIn>
        )}
        <MarginTop margin={'8px'} />
        {file ? FileButton : UploadButton}
      </div>
    );
  }
}

export default FileUploader;
